module.exports = __webpack_public_path__ + "img/kyoto.f05baad0.png";